/**
 * UnifiedExportModal localized copy — shared by both TTS and STT jobs.
 * Re-export shim over /locales/{en,ht,fr,es}.json (export_modal key).
 */
import en from '../locales-shared/en.json'
import ht from '../locales-shared/ht.json'
import fr from '../locales-shared/fr.json'
import es from '../locales-shared/es.json'
import ptBR from '../locales-shared/pt-BR.json'
import zhHans from '../locales-shared/zh-Hans.json'

const COPY = {
  en: en.export_modal,
  ht: ht.export_modal,
  fr: fr.export_modal,
  es: es.export_modal,
  'pt-BR': ptBR.export_modal,
  'zh-Hans': zhHans.export_modal,
}

export default COPY
